import { Box, Button, Card, CardContent, CardHeader, Checkbox, Dialog, DialogActions, DialogTitle, FormControlLabel, IconButton, Input, InputAdornment, TextField, Tooltip, } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DataTable from "react-data-table-component";
import { CustomerSupport, userServices } from "../../services/AllServices";
import errorHandler from "../../utils/errorHandler";
import TableFilter from "../../components/shared/TableFilter";
import { Role_OPTIONS_LIST, STATUS_OPTIONS_LIST, SUPPORT_OPTIONS_LIST } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import { Comment } from "@mui/icons-material";
import { Loader } from "../../components/CustomLoader";
import { debounce } from "lodash";
import { toast } from "react-toastify";
import { fDate } from "../../utils/formatTime";
import dayjs from "dayjs";
import { capitalizeFirstLetter, TrimText } from "../../utils/helpers";
import ViewMessage from "./ViewMessage";
import ViewSupportMessage from "./ViewSupportMessage";

export default function CustomerSupportList() {
  const navigate = useNavigate();
  const [searchItem, setSearchItem] = useState("");
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [status, setStatus] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [viewId, setViewId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loaderDelay, setLoaderDelay] = useState(false);
  const [commentDialog, setCommentDialog] = useState(false);
  const [ComentValue, setCommentValue] = useState("");
  const [commentError, setCommentError] = useState("");
  const [queryStatus, setQueryStatus] = useState([]);
  const [statusId, setStatusId] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [cstatus, setCstatus] = useState("pending");
  const [cmessage, setCmessage] = useState("");

  const [replayData, setReplayData] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleVerifyClose = () => setCommentDialog(false);

  const fetchQuery = async (query) => {
    const body = {
      searchItem: query || "",
      status: queryStatus,
      pageNumber: currentPage,
      pageSize: pageSize,
      roleType: status,
      startDate: startDate || null,
      endDate: endDate || null,
    };
    try {
      setIsLoading(true);
      setLoaderDelay(false);
      const res = await CustomerSupport.getAll(body);
      setTimeout(() => {
        if (res.status === 200) {
          setData(res?.data?.data?.contacts);
          setTotalPages(res?.data?.data?.totalItems);
        }
        setLoaderDelay(true);
      }, 500);
    } catch (err) {
      setData(err?.response?.data?.message?.data);
      errorHandler(err);
      setLoaderDelay(false);
    } finally {
      setIsLoading(false);
      setLoaderDelay(false);
    }
  };

  const debouncedSearch = useCallback(
    debounce((query) => fetchQuery(query), 400),
    [currentPage, pageSize, status, queryStatus, startDate, endDate]
  );

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchItem(query);
    debouncedSearch(query);
  };

  const handlePageChange = (page) => setCurrentPage(page);

  const handleCheckboxChange = (value) => {
    setCstatus(value);
  };
  useEffect(() => {
    fetchQuery(searchItem);
  }, [currentPage, pageSize, status, refresh, queryStatus, startDate, endDate]);

  const columns = [
    {
      name: "S.No.",
      cell: (row, index) => (currentPage - 1) * pageSize + index + 1,
      width:'100px',
    },
    {
      name: "Ticket Id",
      sortable: true,
      selector: (row) => capitalizeFirstLetter(row.ticketId),
      width:'120px',

    },
    {
      name: "Name",
      sortable: true,
      selector: (row) => capitalizeFirstLetter(TrimText(row.name ,25)),
    },
    {
      name: "Email",
      sortable: true,
      selector: (row) => row.email,
    },

    {
      name: "Role Type",
      sortable: true,
      selector: (row) => capitalizeFirstLetter(row.type),
      width:'130px',
    },

    {
      name: "Query Status",
      sortable: true,
      selector: (row) => capitalizeFirstLetter(row.status),
      width:'150px',
    },
    {
      name: "Created At",
      sortable: true,
      selector: (row) => fDate(row.createdAt),
      width:'150px',
    },

    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <Tooltip title="View" placement="top">
            <IconButton
              color="primary"
              onClick={() => {
                setModalShow(true);
                setViewId(row);
              }}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Comment" placement="left">
            <IconButton
              color="primary"
              onClick={() => {
                setCommentDialog(true);
                setStatusId(row.ticketId);
                setReplayData(row);
                setCstatus(row.status);
                setCmessage(row.message);
                setCommentError("");
              }}
            >
              <Comment />
            </IconButton>
          </Tooltip>
         
        </>
      ),
    },
  ];

  const handleVerifySubmit = async () => {
    try {
      if (!ComentValue) {
        setCommentError("Message is required.");
        return;
      }
      const payload = {
        id: statusId,
        email: replayData?.email,
        subject: replayData?.subject,
        message: ComentValue,
        cstatus,
      };
      const response = await CustomerSupport.response(payload);
      // setCommentValue('');
      toast.success(response?.data?.message);
      setCommentDialog(false);
      setRefresh(!refresh);
      setCommentValue("");
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <Card>
      <title> Ticketdash</title>
      <CardHeader title="Customer Support" />
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 2, // Adds spacing between elements
          padding: 2, // Ensures better spacing on smaller screens
        }}
      >
        {/* Start Date Field */}
        <TextField
          label="Start Date"
          type="date"
          className="Customdatefield"
          value={startDate ? new Date(startDate).toISOString().split("T")[0] : ""}
          onChange={(e) => {
            const newDate = e.target.value ? new Date(e.target.value) : null;
            if (newDate) {
              setStartDate(newDate);
              if (endDate && newDate > endDate) {
                setEndDate(newDate); // Adjusts end date if it's before start date
              }
            }
          }}
          onKeyDown={(e) => e.preventDefault()}
          onBlur={(e) => {
            const inputDate = new Date(e.target.value);
            if (inputDate < new Date("2024-01-01") || inputDate > new Date()) {
              setStartDate(null); // Reset if invalid
            }
          }}
          InputLabelProps={{ shrink: true }}
          inputProps={{
            min: "2024-01-01",
            max: dayjs().format("YYYY-MM-DD"),
          }}
          size="small"
          sx={{ minWidth: "160px" }}
        />

        {/* End Date Field */}
        <TextField
          label="End Date"
          type="date"
          className="Customdatefield"
          value={endDate ? new Date(endDate).toISOString().split("T")[0] : ""}
          onChange={(e) => {
            const selectedEndDate = e.target.value ? new Date(e.target.value) : null;
            if (selectedEndDate) {
              if (startDate && selectedEndDate < startDate) {
                return; // Prevents selecting an end date before the start date
              }
              selectedEndDate.setHours(23, 59, 59);
              setEndDate(selectedEndDate);
            }
          }}
          onKeyDown={(e) => e.preventDefault()} // Prevent manual typing
          onBlur={(e) => {
            const inputDate = new Date(e.target.value);
            if (inputDate < new Date("2024-01-01") || inputDate > new Date() || (startDate && inputDate < startDate)) {
              setEndDate(null); // Reset if invalid
            }
          }}
          InputLabelProps={{ shrink: true }}
          inputProps={{
            min: startDate ? new Date(startDate).toISOString().split("T")[0] : "2024-01-01",
            max: dayjs().format("YYYY-MM-DD"),
          }}
          size="small"
          sx={{ minWidth: "160px" }}
        />

        {/* Role Type Filter */}
        <TableFilter
          data={Role_OPTIONS_LIST}
          value={status}
          setValue={setStatus}
          filterName="Role Type"
        />

        {/* Query Status Filter */}
        <TableFilter
          data={SUPPORT_OPTIONS_LIST}
          value={queryStatus}
          setValue={setQueryStatus}
          filterName="Query Status"
        />

        {/* Search Input */}
        <Input
          value={searchItem}
          placeholder="Search By Email"
          onChange={handleSearchChange}
          sx={{ minWidth: "200px", flexGrow: 1 }}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="clear-search"
                onClick={() => {
                  const cleared = "";
                  setSearchItem(cleared);
                  debouncedSearch(cleared);
                }}
              >
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          }
        />

        {/* Clear Button */}
        <Button
          variant="outlined"
          onClick={() => {
            setStartDate(null);
            setEndDate(null);
            setStatus([]);
            setQueryStatus([]);
            setSearchItem("");
          }}
          sx={{
            whiteSpace: "nowrap",
            minWidth: "100px",
          }}
        >
          Clear
        </Button>
      </Box>

      <CardContent>
        <DataTable
          customStyles={{
            headCells: {
              style: {
                fontSize: "15px",
                fontWeight: "bold",
              },
            },
          }}
          columns={columns}
          data={data}
          pagination
          paginationServer
          paginationTotalRows={totalPages}
          onChangePage={handlePageChange}
          paginationPerPage={pageSize}
          paginationRowsPerPageOptions={[5, 10, 20, 50]}
          onChangeRowsPerPage={(currentRowsPerPage) =>
            setPageSize(currentRowsPerPage)
          }
          progressPending={isLoading || !loaderDelay}
          progressComponent={<Loader />}
          className="custom"
        />
      </CardContent>

      <Dialog open={commentDialog} onClose={handleVerifyClose}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <CardHeader
            title="Add Comment"
            titleTypographyProps={{ align: "left", variant: "h6", width: 450 }}
          />

          <IconButton
            edge="end"
            onClick={handleVerifyClose}
            sx={{ color: "black" }}
            className="customicon"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogActions
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 3,
            width: "100%", // Make sure the container takes full width
          }}
        >
          <h5 style={{ textAlign: "center", wordWrap: "break-word" }}>
            Reply To - {cmessage}
          </h5>

          <TextField
            fullWidth
            multiline
            rows={8}
            maxRows={8}
            placeholder="Add Comment"
            onChange={(e) => setCommentValue(e.target.value)}
            sx={{
              marginBottom: 2,
              padding: "12px",
              width: "100%",
              maxWidth: "500px", // Limits size on larger screens but allows shrinking
            }}
          />

          {commentError && (
            <Box sx={{ color: "red", fontSize: "14px", marginBottom: 2 }}>
              {commentError}
            </Box>
          )}

          {/* Checkboxes for status selection */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap", // Allows wrapping on smaller screens
              justifyContent: "center",
              gap: 2,
              marginBottom: 2,
              width: "100%",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={cstatus === "pending"}
                  onChange={() => handleCheckboxChange("pending")}
                />
              }
              label="Pending"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={cstatus === "inProgress"}
                  onChange={() => handleCheckboxChange("inProgress")}
                />
              }
              label="In Progress"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={cstatus === "resolved"}
                  onChange={() => handleCheckboxChange("resolved")}
                />
              }
              label="Resolved"
            />
          </Box>

          <Button
            color="primary"
            variant="contained"
            onClick={() => handleVerifySubmit(status)}
            sx={{
              padding: "10px 20px",
              width: "100%",
              maxWidth: "500px", // Allows the button to shrink but maintains a reasonable size on large screens
              "@media (max-width: 600px)": {
                maxWidth: "90%", // Allows better fit on smaller screens
              },
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {modalShow ? (
         <ViewSupportMessage
         open={modalShow}
         onClose={() => setModalShow(false)}
         data={viewId}
       />
      ) : (
        ""
      )}
    </Card>
  );
}
